import styled from 'styled-components';
import { Col } from 'reactstrap';

export const Container = styled.div`
  background-color: #fff;
  padding: 40px 15px;
  border-radius: 4px;
  max-width: 360px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  height: fit-content;
`;

export const Box = styled(Col)`
  border-radius: 4px;
  padding: 30px;
  background-color: #fff;
  text-align: center;
`;

export const Loading = styled.img`
  margin: 80px auto;
  display: block;
`;

export const Title = styled.h1`
  margin-top: 30px;
  font-weight: lighter;
`;

export const Content = styled.div`
  padding: 15px 0 0;
  margin-top: 15px;
  input[type='submit'].btn {
    margin: 30px 0 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ContentBox/style.js